import React from 'react';
import { DateRange } from 'react-day-picker';
import { ViewsChart } from '../../views/ViewsChart';
import { ViewsSummaryTable } from '../../views/ViewsSummaryTable';
import { usePitchModal } from '../../pitch/usePitchModal';
import { PitchConfigModal } from '../../pitch/PitchConfigModal';
import { PitchQuickModal } from '../../pitch/PitchQuickModal';
import type { VideoPitch } from '@/types/pitch';

interface ViewsTabContentProps {
  date?: DateRange | undefined;
  videoId: string | null;
  isLoading: boolean;
  metricsEnhanced?: any;
}

export function ViewsTabContent({ date, videoId, isLoading: isLoadingProp, metricsEnhanced }: ViewsTabContentProps) {
  // Usar os dados reais do metricsEnhanced
  const isLoading = isLoadingProp || metricsEnhanced?.isLoading;
  const summary = metricsEnhanced?.summary;
  const viewsSeries = metricsEnhanced?.viewsSeries || [];

  // Pitches e timeline para os modais de pitch
  const retentionTimeline = metricsEnhanced?.retentionTimeline || [];
  const videoInfo = metricsEnhanced?.videoInfo;
  const pitches: VideoPitch[] = videoInfo?.pitches ?? [];

  const timelineData = retentionTimeline.map((point: any) => ({
    time: point.time_seconds,
    retention: point.retention_pct,
    viewers_count: point.viewers_count,
  }));

  // Qual modal de pitch está aberto, e para qual pitch
  const pitchModal = usePitchModal();

  // Depois de salvar, refaz o consolidado: a retenção de cada pitch é calculada no backend.
  const refetchMetrics = () => metricsEnhanced?.refetchMetrics?.();

  return (
    <div className="space-y-9">
      {/* Chart com toggles internos */}
      <ViewsChart data={viewsSeries} isLoading={isLoading} />

      {/* Summary Table com gap de 36px (PRD) */}
      <div className="mt-9">
        {summary && (
          <ViewsSummaryTable
            summary={summary}
            isLoading={isLoading}
            pitches={pitches}
            onEditPitch={pitchModal.openQuick}
            onPitchDetails={pitchModal.openDetails}
            videoId={videoId}
            dateRange={date}
            conversionsPlatforms={metricsEnhanced?.conversions?.platforms || []}
          />
        )}
      </div>

      {/* Modal Rápido (Canetinha) - criar, editar ou remover um pitch */}
      <PitchQuickModal
        isOpen={pitchModal.quickOpen}
        onClose={pitchModal.closeQuick}
        videoId={videoInfo?.id ?? null}
        pitches={pitches}
        editingPitchId={pitchModal.quickPitchId}
        durationInSeconds={videoInfo?.duration}
        onSaved={refetchMetrics}
      />

      {/* Modal Completo (Detalhes) - histograma do pitch clicado */}
      <PitchConfigModal
        isOpen={pitchModal.detailsOpen}
        onClose={pitchModal.closeDetails}
        videoId={videoInfo?.id ?? null}
        pitches={pitches}
        pitchId={pitchModal.detailsPitchId}
        durationInSeconds={videoInfo?.duration}
        timelineData={timelineData}
        onSaved={refetchMetrics}
      />
    </div>
  );
}
